import { Box, IconButton } from "@mui/material";
import { useState } from "react";
import { DashIcon, Plus1Icon } from "./Icons";

interface NumberSpinnerProps {
  value?: number;
  onChange?: (v: number) => void;
  min?: number;
  max?: number;
  step?: number;
}

export default function NumberSpinner({
  value,
  onChange,
  min = 0,
  max = 100,
  step = 10,
}: NumberSpinnerProps) {
  const [internalValue, setInternalValue] = useState(value ?? min);
  const current = value ?? internalValue;

  const updateValue = (v: number) => {
    if (v < min || v > max) return;
    setInternalValue(v);
    onChange?.(v);
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        border: `1px solid var(--grey-100)`,
        borderRadius: "8px",
        overflow: "hidden",
        height: "45px",
        width: "130px",
        textAlign: "center",
        backgroundColor: "var(--white)",
      }}
    >
      <IconButton
        onClick={() => updateValue(current - step)}
        disabled={current <= min}
        sx={{
          flex: "0 0 33%",
          borderRight: `1px solid var(--grey-100)`,
          borderRadius: 0,
          height: "100%",
        }}
      >
        <DashIcon style={{ fontSize: 20 }} />
      </IconButton>

      <Box
        sx={{
          flex: "0 0 34%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "18px",
          fontWeight: 600,
          borderRight: `1px solid var(--grey-100)`,
          height: "100%",
        }}
      >
        {current}
      </Box>

      <IconButton
        onClick={() => updateValue(current + step)}
        disabled={current >= max}
        sx={{
          flex: "0 0 33%",
          borderRadius: 0,
          height: "100%",
        }}
      >
        <Plus1Icon style={{ fontSize: 20 }} />
      </IconButton>
    </Box>
  );
}
